import { Component } from "@angular/core";

@Component({
    selector: 'app-access-denied',
    template: require('./access-denied.component.html'),
    styles: [require('./access-denied.component.css')]
})
export class AccessDeniedComponent {}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/layout/access-denied/access-denied.component.ts